import * as Yup from "yup";

const CompetitionGroupCompetitionSchema = () => Yup.object().shape({
  competition_ids: Yup
    .array()
    .label("Competitions")
});

export default CompetitionGroupCompetitionSchema;
